const data = [
  // {
  //   id: 1,
  //   noAcc: "111",
  //   nameAcc: "Kas",
  //   kode: "KAS",
  //   kolom: "7",
  //   keterangan: "Penerimaan tunai oleh koperasi dari transaksi",
  // },
  // {
  //   id: 2,
  //   noAcc: "112",
  //   nameAcc: "Bank",
  //   kode: "BNK",
  //   kolom: "7",
  //   keterangan: "Penerimaan tunai oleh koperasi dari transaksi",
  // },
  // {
  //   id: 3,
  //   noAcc: "1121",
  //   nameAcc: "Bank Mandiri",
  //   kode: "BNKM",
  //   kolom: "8",
  //   keterangan: "Penerimaan tunai oleh koperasi dari transaksi",
  // },
];

export default data;
